import React from "react";
import { formatDistanceWithSuffix } from "tsi-common-react/src/apps/retail/helpers";
import { IRetailStoreWithDistance } from "tsi-common-react/src/models/location.interfaces";
import { formatPhoneNumber } from "tsi-common-react/src/utils/format";

interface IProps {
    store: IRetailStoreWithDistance;
}

export const Store = (props: IProps): React.ReactNode => {
    const phoneInUSFormat = props.store.phone
        ? formatPhoneNumber(props.store.phone)
        : "";
    return (
        <li className="pdp-modal-store">
            <span className="pdp-modal-store__name">{props.store.name}</span>
            <div className="pdp-modal-store__address">
                <span className="pdp-modal-store__distance">
                    {formatDistanceWithSuffix(props.store.distance)}
                </span>
                <div className="pdp-modal-store__address-line">
                    {props.store.address}
                    {props.store.address2}
                    <span>
                        {props.store.city}, {props.store.state}
                    </span>
                </div>
                {phoneInUSFormat && (
                    <div className="pdp-modal-store__address-line">
                        <a
                            href={`tel:${props.store.phone}`}
                            className="pdp-modal__link"
                        >
                            {phoneInUSFormat}
                        </a>
                    </div>
                )}
            </div>
        </li>
    );
};
